var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BandDescend'),_c('HomeMailingList'),_c('HomeFeaturedStore'),_c('HomeFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }